<div class="modal-header">
  <h4 class="modal-title">Set Up Text Message Verification</h4>
  <button type="button" class="close" aria-label="Close" (click)="modal.close('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form id="phoneFactorForm" [formGroup]="phoneFactorForm">
    <div class="row">
      <div class="col-12" *ngIf="(!user.factor?.smsFactorEnabled && !user.factor?.phoneNumber && !smsMFAPending) || smsMFAAction === 'update'">
        <p>Enter the phone number the user will use to receive codes via text message, then click
          <strong>Send Code</strong> to verify that it works.</p>
        <div class="form-group input-required">
          <label for="phoneNumber">Phone number</label>
          <input id="phoneNumber" formControlName="phoneNumber" value="" type="text" minlength=10 maxlength=10 required>
          <br/>
          <small *ngIf="phoneFactorForm.controls['phoneNumber']?.errors && phoneFactorForm.controls['phoneNumber'].touched" class="text-danger">Please enter a valid 10 digit phone number.</small>
        </div>
      </div>
      <div class="col-12" *ngIf='smsMFAPending'>
        <p> Please contact {{user.firstName}} {{user.lastName}} for the passcode and enter it below. {{user.firstName}} {{user.lastName}}
          should receive a message in less than a minute.</p>
        <div class="form-group  input-required">
          <label for="smsPhoneCode">Enter code</label>
          <input id="smsPhoneCode" formControlName="smsPhoneCode" value="" type="text" required>
          <br>
        </div>
      </div>
      <div class="col-12" *ngIf="(user.factor?.smsFactorEnabled && smsMFAAction !== 'update' && !smsMFAPending)">
        <p>
          <strong>{{user.firstName}} {{user.lastName}}</strong>'s phone number
          <strong>{{user.factor?.phoneNumber}}</strong>
          has been verified and is configured for extra verification via text message.</p>
        <p> Click
          <strong>Update</strong> to change this user's phone number for SMS verification.</p>
        <p> Click
          <strong>Disable</strong> to stop using user's phone for verification in the event user's phone is lost or stolen.</p>
      </div>
      <div class="col-12" *ngIf="(!user.factor?.smsFactorEnabled && user.factor?.phoneNumber && smsMFAAction !== 'update' && !smsMFAPending)">
        <p>
          <strong>{{user.firstName}} {{user.lastName}}</strong>'s phone number
          <strong>{{user.factor?.phoneNumber}}</strong>
          has already been verified, but has not been authorized by you for extra verification.</p>
        <p> Click
          <strong>Authorize</strong> to approve this number and complete the setup.</p>
        <p> Click
          <strong>Update</strong> to change this user's phone number for SMS verification.</p>
        <p> Click
          <strong>Cancel</strong> if you don't want to set up this verification method right now.</p>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" [disabled]="posting || phoneFactorForm.controls['phoneNumber']?.errors" *ngIf="(!user.factor?.smsFactorEnabled && !user.factor?.phoneNumber && !smsMFAPending) || smsMFAAction === 'update'"
    (click)="submit()">Send Code</button>
  <button type="button" class="btn btn-primary" [disabled]="phoneFactorForm.controls['smsPhoneCode'].errors?.required" *ngIf="smsMFAPending" (click)="submit()">Activate</button>
  <button type="button" class="btn btn-primary" [disabled]="posting" *ngIf="(!user.factor?.smsFactorEnabled && user.factor?.phoneNumber && smsMFAAction !== 'update' && !smsMFAPending)"
    (click)="authorize()">Authorize</button>
  <button type="button" class="btn btn-primary" [disabled]="posting" *ngIf="(user.factor?.smsFactorEnabled || (!user.factor?.smsFactorEnabled && user.factor?.phoneNumber))
  && smsMFAAction !== 'update' && !smsMFAPending" (click)="update()">Update</button>
  <button type="button" class="btn btn-primary" [disabled]="posting" *ngIf="(!smsMFAPending && user.factor?.smsFactorEnabled && smsMFAAction !== 'update')"
    (click)="modal.close('disable')">Disable</button>
  <button type="button" class="btn btn-cancel" (click)="modal.close()">Cancel</button>
</div>
